import React from 'react';

const ButtonViolet = () => {

  return (
    <>
        <button className='form-input-btn violet' type='submit'>
          Generuj Stopkę
        </button>
    </>
  );
};

export default ButtonViolet;